/**
 * @description This returns the MSAL Access Token, if the token is expired then calls refreshToken()
 * @param {*} vm, token(tells wheather msal_token or av_msal_token, accordingly this gets passed in refreshTokenMethod)
 * @returns the MSAL Access Token
 */

import {AV_SILENT_TOKEN_REFRESH_SCOPES, CLIENT_ID, Redirect_Uri, Tenant} from "@/config/constants";
import {
    compareAsc,
} from "date-fns";
import { PublicClientApplication } from "@azure/msal-browser";
import axios from "axios";
import instance from "@/utils/axiosForMsal";
import AxiosFetchForMsal from "@/utils/axiosForMsal";

export async function refreshToken() {
    const msalConfig = {
            auth: {
                clientId: CLIENT_ID,
                    authority: `https://login.microsoftonline.com/${Tenant}/`,
                    navigateToLoginRequestUrl: true,
                    redirectUri: Redirect_Uri,
                    postLogoutRedirectUri: Redirect_Uri,
            },
            cache: {
                cacheLocation: "sessionStorage",
            },
        };

    const msalInstance = new PublicClientApplication(msalConfig);
    const currentAccount = msalInstance.getAllAccounts()[0];
    const scopes = AV_SILENT_TOKEN_REFRESH_SCOPES(currentAccount).scopes;
        const tokens = await msalInstance
            .acquireTokenSilent({
            account: currentAccount,
            scopes: scopes,
            forceRefresh: true,
        }).then((resp) => {
                if (resp !== null) {
                  //console.log("inside refresh tken");
                  const { idToken, accessToken } = resp;
                  sessionStorage.setItem("av_msal_token", JSON.stringify(resp));
                  return { idToken, accessToken};
                }
            })
            .catch(function (error) {
                console.error(error);
            });
        return tokens;
}

/*, token = 'msal_token'*/
export async function getMsalToken() {
    const { expiresOn } = JSON.parse(sessionStorage.getItem("av_msal_token"));
    if (compareAsc(new Date(expiresOn), new Date()) === -1) {
        const { accessToken } = await refreshToken();
        return accessToken;
    } else {
        const { accessToken } = JSON.parse(sessionStorage.getItem("av_msal_token"));
        return accessToken;
    }
}

export async function getMsalIdToken() {
    const { idToken } = await refreshToken();
    AxiosFetchForMsal.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
    axios.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
    instance.defaults.headers.common["Authorization"] = `Bearer ${idToken}`;
    //sessionStorage.setItem('av_msal_token', JSON.stringify({idToken: idToken}));
    return idToken;
}
